<template>
  <v-dialog v-if="false" />
</template>

<script>

import ApiRepository from "../repositories/ApiRepository";

export default {
    name: 'FactoringLogic',
    data: () => ({ }),
    created () {
        this.$root.$on('updateFactoring', (event) => {
            this.updateFactoring(event.id, event.status);
        });
        this.$root.$on('hideFactoring', (event) => {
            this.hideFactoring(event.id);
        });
    },
    methods: {
        updateFactoring (id, status) {
            ApiRepository.updateFactoring(id, status)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Petition modified successfully!'), color: 'success'});
                    this.$root.$emit('refreshCompensations');
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.Error modifying petition'), color: 'error'});
                    console.error(err);
                    this.$root.$emit('refreshCompensations');
                });
        },
        hideFactoring (id) {
            ApiRepository.hideFactoring(id)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Succes.Bypay deleted successfully!')});
                    this.$root.$emit('refreshCompensations');
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.Error deleting bypay'), color: 'error'});
                    console.error(err);
                    this.$root.$emit('refreshCompensations');
                });
        }
    }
};
</script>
